import { useEffect } from 'react';
import { useLocation } from 'react-router';
import UserFormModal from '../../users/components/userFormModal/UserFormModal';

import ErrorPiecework from '../../../components/Modals/ErrorPiecework';
import FolderDeleteModal from '../../folders/components/folderDeleteModal/FolderDeleteModal';

import { useAppDispatch, useAppSelector } from '../../../App/redux/store';
import ComparativeStudyDeleteModal from '../../../components/ComparativeStudies/ComparativeStudyDeleteModal';
import ComparativeStudyModalContent from '../../../components/ComparativeStudies/Details/ComparativeStudyModalContent';
import NoUrbaneaseAccountModal from '../../../components/linksToUrbanease/NoUrbaneaseAccountModal';
import ProcedureEventsModal from '../../../components/Modals/ProcedureEventsModal';
import AdDetails from '../../ad/components/adDetails/AdDetails';
import AdsDeleteModal from '../../ad/components/adsDeleteModal/AdsDeleteModal';
import ChooseFolderModal from '../../folders/components/chooseFolderModal/ChooseFolderModal';
import FolderEditModal from '../../folders/components/folderEditModal/FolderEditModal';
import AskForSubscriptionUpdateModal from '../../subscription/components/askForSubscriptionUpdateModal/AskForSubscriptionUpdateModal';

import AskForSubscriptionUpdateSummaryModal from '../../subscription/components/askForSubscriptionUpdateSummaryModal/AskForSubscriptionUpdateSummaryModal';
import { getModalsState, modalsActions } from '../modalsSlice';
import Confirmation from './confirmation/Confirmation';
import Modal from './modal/Modal';

const ModalContainer = () => {
  const { pathname } = useLocation();
  const {
    chooseFolder,
    updateFolder,
    deleteFolder,
    subscription,
    confirmation,
    deleteAds,
    errorPiecework,
    adDetails,
    createOrUpdateUser,
    notificationBell,
    noUrbaneaseAccount,
    deleteComparativeStudy,
    comparativeStudy,
    subscriptionSummary,
  } = useAppSelector(getModalsState);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(modalsActions.reset());
  }, [pathname]);

  return (
    <>
      {false && (
        <div
          className="overlay"
          onClick={() => dispatch(modalsActions.reset())}
        ></div>
      )}
      {deleteComparativeStudy && <ComparativeStudyDeleteModal />}
      {comparativeStudy && <ComparativeStudyModalContent />}
      {chooseFolder && (
        <ChooseFolderModal
          action={chooseFolder.action}
          currentFolderIdIri={chooseFolder.currentFolderIdIri}
        />
      )}
      {updateFolder && <FolderEditModal />}
      {deleteFolder && <FolderDeleteModal />}
      {deleteAds && <AdsDeleteModal />}
      {errorPiecework && <ErrorPiecework />}
      {notificationBell && <ProcedureEventsModal />}
      {subscription && <AskForSubscriptionUpdateModal />}
      {adDetails && (
        <Modal>
          <AdDetails adIdIri={adDetails} />
        </Modal>
      )}
      {createOrUpdateUser.open && <UserFormModal user={createOrUpdateUser.entity} />}
      {subscriptionSummary && (
        <AskForSubscriptionUpdateSummaryModal datas={subscriptionSummary} />
      )}
      {confirmation && (
        <Confirmation
          message="Vos modifications ne sont pas enregistrés. Souhaitez-vous quitter sans les sauvegarder?"
          cancelBtnText="RETOUR AU FORMULAIRE"
          confirmBtnText="QUITTER"
          redirectPath="details-dossier"
        />
      )}
      {noUrbaneaseAccount && (
        <NoUrbaneaseAccountModal errorStatus={noUrbaneaseAccount.error} />
      )}
    </>
  );
};

export default ModalContainer;
